export default __webpack_public_path__ + "static/media/teemuPaananen.64d21de4.jpg";